// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"TileFooter_footerContainer__2w6Y3","actionButton":"TileFooter_actionButton__3BGG2","buttonText":"TileFooter_buttonText__2EEQI"};